module.exports = __webpack_public_path__ + "static/img/n-clock-check.99ff0438.png";